import { Channel } from '@at/sauron-platform-core/lib/types';
const isUsedCar = (channel, vehicleCondition) => {
    return channel === Channel.cars && vehicleCondition.toUpperCase() === 'USED';
};
const isUsedCarOrVan = (channel, vehicleCondition) => {
    return (channel === Channel.cars || channel === Channel.vans) && vehicleCondition.toUpperCase() === 'USED';
};
const hasATFinanceOlaProduct = (dealerProducts) => dealerProducts.includes('ATFINANCEOLA');
const hasACFinanceOlaProduct = (dealerProducts) => dealerProducts.includes('ACFINANCEOLA');
export const isOnlineFinanceApplication = (channel, dealerProducts, vehicleCondition) => {
    return ((hasATFinanceOlaProduct(dealerProducts) || hasACFinanceOlaProduct(dealerProducts)) &&
        isUsedCar(channel, vehicleCondition));
};
export const isMeetingATOnlineFinanceApplicationCriteria = (channel, dealerProducts, vehicleCondition) => {
    return hasATFinanceOlaProduct(dealerProducts) && isUsedCar(channel, vehicleCondition);
};
export const isMeetingACOnlineFinanceApplicationCriteria = (channel, dealerProducts, vehicleCondition) => {
    return hasACFinanceOlaProduct(dealerProducts) && isUsedCar(channel, vehicleCondition);
};
export const hasBrokerEnabled = (channel, dealerProducts, vehicleCondition) => {
    return dealerProducts.includes('ATBROKER') && isUsedCarOrVan(channel, vehicleCondition);
};
